/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 13.05.2016
 *
 */

import { ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';
import ClassNames from '../constants/ClassNames';
import MapConfigWebApi from '../webapi/MapConfigWebApi';

export default class MapConfigStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.MapConfig, MapConfigWebApi.allListGroupMapConfigs /* good idea to use the "all" api? */, MapConfigWebApi.get);
    }

    getDefaultMapConfig() {
        return this.getRemoteData('GroupDefaultMapConfig');
    }

    getFallbackMapConfig() {
        return {
            'boundingBox': {
                'latitudeMax': 49.872070099704835,
                'latitudeMin': 47.31508638552833,
                'longitudeMax': 11.09619140625,
                'longitudeMin': 7.14111328125
            },
            'plugins': [
                'map/plugins/DefaultPosition',
                'map/plugins/MapConfigPlugin',
                'map/plugins/FliwasOrganizationDefaultPositionPlugin'
            ],
            'description': '',
            'title': 'Fallback MapConfig',
            'uuid': 'fallback_default_mapconfig',
            'defaultBaseLayerId': -1,
            'baseLayer': [
                {
                    'description': 'OSM-StaticLayer',
                    'title': 'OSM-StaticLayer',
                    'type': 'LogicalLayer',
                    'uuid': 'lubworg_gb_t1a_t2',
                    'children': [ {
                        'logicalLayerId': -1,
                        'typeKey': 'leaflet-tile-layer',
                        'id': -1,
                        'title': 'OSM-StaticLayer',
                        'type': 'LayerDataSource',
                        'config': '{  "url": "https://maps.omniscale.net/v2/fliwas-e278fbd2/style.default/{z}/{x}/{y}.png" }'
                    } ],
                    'id': -1,
                    'zIndex': -1
                }
            ],
            'children': [],
            'id': -1
        }
    }

}





// WEBPACK FOOTER //
// ./js/stores/MapConfigStore.js